@layer molecules {
  .m-box {
    --btn-group--pbs: var(--fdt-core-spacing-5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: var(--fdt-semantic-borderwidth-default) solid var(--fdt-semantic-color-border-subtle);
    padding: var(--fdt-core-spacing-5);
  }
  .m-box__content {
    max-width: 450px;
  }
  .m-box__picture {
    max-width: 120px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiQzpcXGlvXFxldGV4LWh1YnN0ZXJcXHNyY1xcRnJvbnRlbmRcXGhlYWRsZXNzXFxtb2R1bGVzXFxldGV4XFxzcmNcXGNvbXBvbmVudHNcXGJveCIsInNvdXJjZXMiOlsiYm94LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtJQUNFO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFFQTs7RUFHRjtJQUNFOztFQUdGO0lBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyJAbGF5ZXIgbW9sZWN1bGVzIHtcclxuICAubS1ib3gge1xyXG4gICAgLS1idG4tZ3JvdXAtLXBiczogdmFyKC0tZmR0LWNvcmUtc3BhY2luZy01KTtcclxuICAgIGRpc3BsYXk6IGZsZXg7XHJcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xyXG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XHJcbiAgICBib3JkZXI6IHZhcigtLWZkdC1zZW1hbnRpYy1ib3JkZXJ3aWR0aC1kZWZhdWx0KSBzb2xpZFxyXG4gICAgICB2YXIoLS1mZHQtc2VtYW50aWMtY29sb3ItYm9yZGVyLXN1YnRsZSk7XHJcbiAgICBwYWRkaW5nOiB2YXIoLS1mZHQtY29yZS1zcGFjaW5nLTUpO1xyXG4gIH1cclxuXHJcbiAgLm0tYm94X19jb250ZW50IHtcclxuICAgIG1heC13aWR0aDogNDUwcHg7XHJcbiAgfVxyXG5cclxuICAubS1ib3hfX3BpY3R1cmUge1xyXG4gICAgbWF4LXdpZHRoOiAxMjBweDtcclxuICB9XHJcbn1cclxuIl19 */